<template>
  <main-container>
    <common-header/>
    <section-heading>エラー</section-heading>
    <contents-container>
      <contents-text v-html="errorMessage"></contents-text>
      <contents-text variant="support">修理代金サポートセンター<br>0120-914-554<br>年中無休／通話料無料<br>（9：00～20：00）</contents-text>
      <button-container>
        <button-main href="https://pass.auone.jp/anshin/">auスマートパス 安心サービス</button-main>
      </button-container>
    </contents-container>
    <common-footer/>
  </main-container>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader'
import CommonFooter from '../components/common/CommonFooter'
import MainContainer from '../components/container/MainContainer'
import ContentsContainer from '../components/container/ContentsContainer'
import SectionHeading from '../components/heading/SectionHeading'
import ContentsText from '../components/text/ContentsText'
import ButtonContainer from '../components/button/ButtonContainer'
import ButtonMain from '../components/button/ButtonMain'

export default {
  name: "rep080",
  components: {
    CommonHeader,
    CommonFooter,
    MainContainer,
    ContentsContainer,
    SectionHeading,
    ContentsText,
    ButtonContainer,
    ButtonMain
  },
  metaInfo: {
    title: 'エラー',
  },
  computed: {
    errorMessage() {
      return this.$store.getters.getErrorMessage.replace(/\\n/g, '<br/>')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
